<template>
    <div id="esportsMember_manage">
        <el-table :data="tableData" style="width: 100%" :max-height="maxHeight_Table">
            <el-table-column prop="title" label="礼包名称" align="center"></el-table-column>
            <el-table-column prop="level" label="归属等级" align="center"></el-table-column>
            <el-table-column prop="receive_date" label="发放时间" align="center"></el-table-column>
            <el-table-column prop="receive_type" label="领取要求" align="center"></el-table-column>
            <el-table-column prop="status" label="礼包状态" align="center">
                <template slot-scope="scope">
                    <div>
                        <span style="color:#FE2F2F" v-if="scope.row.status == 0">未开启</span>
                        <span style="color:#00A962" v-if="scope.row.status == 1">已开启</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="操作" align="right" width="120">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleChangeStatus(scope.row)"
                        v-if="scope.row.status == 0">开启</el-button>
                    <el-button type="text" style="color:#FE2F2F" @click="handleChangeStatus(scope.row)"
                        v-if="scope.row.status == 1">关闭</el-button>
                    <el-button type="text" @click="toSetUP(scope.row)">设置礼包</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>

export default {
    data() {
        return {
            maxHeight_Table: '500px',
            tableData: [{}]
        }
    },
    created() {
        this.getList()
    },
    computed: {},
    methods: {
        // 修改礼包状态
        handleChangeStatus(row) {
            console.log(row)
            let data = {
                id: row.id
            }
            console.log('修改礼物状态data',data)
            this.my_request('admin/member/gift/status', data, 'PUT').then(res => {
                console.log('修改礼物状态结果', res);
                let { code } = res.data
                if (200 == code) {
                    this.$message.success('修改成功！')
                    this.getList()
                } else {
                    this.$message.error('修改失败')
                }
            })
        },
        // 跳转到设置礼包 
        toSetUP(row) {
            console.log(row)
            this.$router.push({ path: `/EsportsMember/SetUPPackages?id=${row.id}` })
        },
        // 获取礼包列表
        getList() {
            this.my_request('admin/member/gift').then(res => {
                console.log('获取礼包列表结果', res);
                let { code, data } = res.data
                if (200 == code) {
                    this.tableData = data
                }
            })
        },
    }
}

</script>

<style lang="scss" scoped></style>